let ctx = null;
let hum = null;

function ensureCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function beep(freq = 880, dur = 0.07, gain = 0.035) {
  try {
    const c = ensureCtx();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "square";
    o.frequency.setValueAtTime(freq, c.currentTime);
    o.frequency.exponentialRampToValueAtTime(Math.max(freq / 2, 40), c.currentTime + dur);
    g.gain.setValueAtTime(gain, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    o.connect(g).connect(c.destination);
    o.start();
    o.stop(c.currentTime + dur);
  } catch (e) {
    console.warn("[gumz:audio]", e?.message || e);
  }
}

export function setHum(on) {
  try {
    const c = ensureCtx();
    if (on && !hum) {
      const o = c.createOscillator();
      const o2 = c.createOscillator();
      const g = c.createGain();
      const f = c.createBiquadFilter();
      o.type = "sawtooth";
      o.frequency.value = 52;
      o2.type = "sine";
      o2.frequency.value = 104.5;
      f.type = "lowpass";
      f.frequency.value = 260;
      g.gain.value = 0.016;
      o.connect(f);
      o2.connect(f);
      f.connect(g).connect(c.destination);
      o.start();
      o2.start();
      hum = { o, o2, g };
    } else if (!on && hum) {
      hum.g.gain.linearRampToValueAtTime(0.0001, c.currentTime + 0.25);
      const nodes = hum;
      hum = null;
      setTimeout(() => {
        nodes.o.stop();
        nodes.o2.stop();
      }, 400);
    }
  } catch (e) {
    console.warn("[gumz:audio]", e?.message || e);
  }
}

export function doorChime() {
  try {
    const c = ensureCtx();
    if (c.state !== "running") return;
    [[1046.5, 0], [1318.5, 0.28], [1568, 0.56]].forEach(([f, at]) => {
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = "sine";
      o.frequency.value = f;
      const t0 = c.currentTime + at;
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(0.022, t0 + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.9);
      o.connect(g).connect(c.destination);
      o.start(t0);
      o.stop(t0 + 0.95);
    });
  } catch (e) {
    console.warn("[gumz:audio]", e?.message || e);
  }
}

export function doorSlide(dur = 1.6) {
  try {
    const c = ensureCtx();
    if (c.state !== "running") return;
    const len = Math.floor(c.sampleRate * dur);
    const buf = c.createBuffer(1, len, c.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
    const src = c.createBufferSource();
    src.buffer = buf;
    const f = c.createBiquadFilter();
    f.type = "bandpass";
    f.Q.value = 0.9;
    f.frequency.setValueAtTime(320, c.currentTime);
    f.frequency.linearRampToValueAtTime(900, c.currentTime + dur * 0.7);
    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.028, c.currentTime + 0.12);
    g.gain.setValueAtTime(0.028, c.currentTime + dur * 0.75);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    src.connect(f).connect(g).connect(c.destination);
    src.start();
    const thud = c.createOscillator();
    const tg = c.createGain();
    thud.type = "sine";
    thud.frequency.value = 90;
    tg.gain.setValueAtTime(0.0001, c.currentTime + dur * 0.8);
    tg.gain.exponentialRampToValueAtTime(0.035, c.currentTime + dur * 0.82);
    tg.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur * 0.8 + 0.35);
    thud.connect(tg).connect(c.destination);
    thud.start(c.currentTime + dur * 0.8);
    thud.stop(c.currentTime + dur * 0.8 + 0.4);
  } catch (e) {
    console.warn("[gumz:audio]", e?.message || e);
  }
}
